import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "../../asset/style/landing.css";

const LANGS = [
  { code: "pt", label: "PT", flag: "🇵🇹" },
  { code: "en", label: "EN", flag: "🇬🇧" },
  { code: "es", label: "ES", flag: "🇪🇸" },
  { code: "fr", label: "FR", flag: "🇫🇷" },
  { code: "de", label: "DE", flag: "🇩🇪" },
  { code: "it", label: "IT", flag: "🇮🇹" },
];

const LandingShell = ({ title, children }) => {
  const year = new Date().getFullYear();
  const { i18n } = useTranslation();
  const [langOpen, setLangOpen] = useState(false);
  const navigate = useNavigate();
  const currentLang = (i18n.language || "pt").substring(0, 2).toUpperCase();

  const changeLang = (code) => {
    i18n.changeLanguage(code);
    localStorage.setItem("lng", code);
    setLangOpen(false);
  };

  return (
    <div className="tp-landing">
      <header className="tp-nav">
        <div className="tp-nav-inner">
          <a href="/" className="tp-brand" onClick={(e) => { e.preventDefault(); navigate("/"); }}>
            <img
              src="https://tp.software/libs/images/tpsoftware-green-white.png"
              alt="TP Software"
              className="tp-brand-logo"
            />
          </a>
          <nav className="tp-nav-links">
            <a href="/#features">Funcionalidades</a>
            <a href="/#stats">Clientes</a>
            <a href="/#expomecanica">Expomecânica</a>
            <a href="/#contacto">Contacto</a>
          </nav>
          <div className="tp-nav-cta">
            <div className="tp-lang-wrap">
              <button className="tp-lang-btn" onClick={() => setLangOpen(!langOpen)}>
                🌐 {currentLang} ▾
              </button>
              {langOpen && (
                <div className="tp-lang-dropdown">
                  {LANGS.map((l) => (
                    <button
                      key={l.code}
                      className={`tp-lang-opt${i18n.language?.startsWith(l.code) ? " active" : ""}`}
                      onClick={() => changeLang(l.code)}
                    >
                      <span className="tp-lang-flag">{l.flag}</span>
                      <span>{l.label}</span>
                    </button>
                  ))}
                </div>
              )}
            </div>
            <Link to="/login" className="tp-btn-ghost">Entrar</Link>
            <Link to="/signup" className="tp-btn-primary">Registo</Link>
          </div>
        </div>
      </header>

      <section className="tp-page-hero">
        <div className="tp-page-hero-inner">
          <h1>{title}</h1>
        </div>
      </section>

      <section className="tp-page-body">
        <div className="tp-page-body-inner">{children}</div>
      </section>

      <footer className="tp-footer">
        <div className="tp-footer-inner">
          <div className="tp-footer-brand">
            <Link to="/" className="tp-brand">
              <img
                src="https://tp.software/libs/images/tpsoftware-green-white.png"
                alt="TP Software"
                className="tp-brand-logo"
              />
            </Link>
            <p>Gestão de centros de abate automóvel.</p>
          </div>
          <div className="tp-footer-cols">
            <div>
              <h4>Produto</h4>
              <a href="/#features">Funcionalidades</a>
              <a href="/#stats">Clientes</a>
              <a href="/#expomecanica">Expomecânica</a>
            </div>
            <div>
              <h4>Legal</h4>
              <Link to="/terms-condition">Termos</Link>
              <Link to="/privacy-policy">Privacidade</Link>
              <Link to="/faq">FAQ</Link>
            </div>
            <div>
              <h4>Conta</h4>
              <Link to="/login">Entrar</Link>
              <Link to="/signup">Registo</Link>
            </div>
          </div>
        </div>
        <div className="tp-footer-bottom">
          © {year} TP Software · TelePeças, Lda · Todos os direitos reservados
        </div>
      </footer>
    </div>
  );
};

export default LandingShell;
